// @ts-nocheck
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { setViewer } from "@/lib/liveSheets";
import { Lock } from "lucide-react";

interface Props {
  allowedEmails: string[];
  eventName?: string;
  onPassed: () => void;
}

export default function EmailGate({ allowedEmails, eventName, onPassed }: Props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const lower = email.toLowerCase().trim();
    if (!name.trim()) return setErr("Please enter your name.");
    if (!lower) return setErr("Please enter your email.");
    if (!allowedEmails.map((x) => x.toLowerCase()).includes(lower)) {
      return setErr("This email is not on the access list for this sheet.");
    }
    setViewer(name.trim(), lower);
    onPassed();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-white rounded-lg shadow-md p-6 space-y-4"
      >
        <div className="flex items-center gap-2 text-[#002E62]">
          <Lock className="h-5 w-5" />
          <h1 className="text-lg font-semibold">Verify your access</h1>
        </div>
        <p className="text-sm text-muted-foreground">
          {eventName ? `“${eventName}” is ` : "This sheet is "}restricted. Enter the
          name and email this link was shared with.
        </p>
        <div className="space-y-2">
          <Input placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} />
          <Input placeholder="Your email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        {err && <p className="text-sm text-destructive">{err}</p>}
        <Button type="submit" className="w-full bg-[#002E62] hover:bg-[#002E62]/90">
          Continue
        </Button>
      </form>
    </div>
  );
}
